import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-529601ba")
const _hoisted_1 = {
  key: 1,
  class: "p-d-flex p-flex-wrap"
}
const _hoisted_2 = { class: "p-d-flex p-flex-column p-mr-5 p-mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "search" }, "Nombre y apellido", -1)
const _hoisted_4 = {
  id: "search",
  class: "p-input-icon-right p-mt-2"
}
const _hoisted_5 = {
  class: "p-d-flex p-flex-column p-mr-5 p-mb-4",
  style: {"max-width":"300px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "coursePlans" }, "Cursos", -1)
const _hoisted_7 = {
  id: "coursePlans",
  class: "p-mt-2"
}
const _hoisted_8 = { class: "p-d-flex p-flex-column p-mr-5 p-mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Accion", -1)
const _hoisted_10 = {
  id: "status",
  class: "p-mt-2"
}
const _hoisted_11 = { class: "p-d-flex p-flex-column p-mb-4 p-jc-end" }
const _hoisted_12 = {
  id: "status",
  class: "p-mt-2"
}
const _hoisted_13 = ["for"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold p-pt-2 p-pb-2 header" }, "Vistas guardados", -1)
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "p-jc-between p-mt-1 p-d-flex" }
const _hoisted_17 = {
  key: 2,
  class: "p-col-3"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CoursePlanSelectorCustom = _resolveComponent("CoursePlanSelectorCustom")!
  const _component_TutorsActionSelector = _resolveComponent("TutorsActionSelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_TutorsTable = _resolveComponent("TutorsTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.nameFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.nameFilter = $event)),
                placeholder: "Nombre y apellido"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_CoursePlanSelectorCustom, {
                coursePlans: _ctx.allCoursePlans,
                multipleSelection: true,
                modelValue: _ctx.coursesFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.coursesFilter = $event)),
                onApplyFilter: _ctx.applyFilter
              }, null, 8, ["coursePlans", "modelValue", "onApplyFilter"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_TutorsActionSelector, {
                modelValue: _ctx.actionFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionFilter = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-text-left btn-custom-view",
                icon: "pi pi-chevron-down",
                iconPos: "right",
                label: 'Tabla',
                onClick: _ctx.toggle,
                "aria:haspopup": "true",
                "aria-controls": "overlay_panel_custom"
              }, null, 8, ["onClick"])
            ]),
            _createVNode(_component_OverlayPanel, {
              ref: "op",
              appendTo: "body",
              class: "p-mt-0 bg-gray-400",
              id: "overlay_panel_custom",
              style: {"width":"208px","min-height":"300px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScrollPanel, { style: {"width":"100%","max-height":"200px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: column,
                        class: "p-mb-2 p-d-flex p-ai-center"
                      }, [
                        _createVNode(_component_Checkbox, {
                          class: "p-m-2 bg-gray-400",
                          id: column.field,
                          name: "selectedColumns",
                          value: column.header,
                          modelValue: _ctx.showCol,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCol = $event)),
                          onClick: ($event: any) => (_ctx.clickCheck(column.header))
                        }, null, 8, ["id", "value", "modelValue", "onClick"]),
                        _createElementVNode("label", {
                          for: column.field
                        }, _toDisplayString(column.header), 9, _hoisted_13)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _hoisted_14,
                (_ctx.allCustomViews.length)
                  ? (_openBlock(), _createBlock(_component_ScrollPanel, {
                      key: 0,
                      style: {"width":"100%","max-height":"100px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCustomViews, (view) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: view.name.trim(),
                            class: "p-d-flex p-jc-between p-ai-center custom-item",
                            onClick: ($event: any) => (_ctx.selectView(view))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(view.name), 1),
                            _createVNode(_component_Button, {
                              onClick: ($event: any) => (_ctx.deleteFilter(view)),
                              class: "p-button-rounded p-button-text",
                              icon: "pi pi-trash"
                            }, null, 8, ["onClick"])
                          ], 8, _hoisted_15))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Button, {
                    type: "button",
                    class: "p-button-text",
                    label: 'Cancelar'
                  }),
                  _createVNode(_component_Button, {
                    type: "button",
                    label: 'Guardar',
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialogOpen()))
                  })
                ])
              ]),
              _: 1
            }, 512)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.viewSelected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Chip, {
            removable: "",
            onRemove: _ctx.removeSelectedView,
            class: "custom-chip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.viewSelected.name), 1)
            ]),
            _: 1
          }, 8, ["onRemove"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "scroll-infinite",
      onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      _createVNode(_component_TutorsTable, {
        showCol: _ctx.showCol,
        staffTracing: _ctx.staffTracing,
        nameFilter: _ctx.nameFilter,
        stateFilter: _ctx.stateFilter,
        coursesFilter: _ctx.coursesFilter
      }, null, 8, ["showCol", "staffTracing", "nameFilter", "stateFilter", "coursesFilter"])
    ], 32),
    _createVNode(_component_Dialog, {
      header: "Guardar vista",
      visible: _ctx.showDialog,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDialog = $event)),
      style: {width: '350px'},
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancelar",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDialogClose())),
          class: "p-button-text button-underlined"
        }),
        _createVNode(_component_Button, {
          label: "Guardar",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveFilterView()))
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_InputText, {
          modelValue: _ctx.filterNameInput,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filterNameInput = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}